import React, { Fragment } from 'react';

const levels = {
	0: 'Unknown risk level',
	1: 'Normal safety precautions',
	2: 'High level of caution',
	3: 'Reconsider travel',
	4: 'Do not travel'
};

const SeverityDescription = ({ level }) => {
	return <Fragment>{levels[level]}</Fragment>;
};

export default SeverityDescription;
